import keyWrapper from '@bufferapp/keywrapper';

export const actionTypes = keyWrapper('thirdparty', {
  BUGSNAG: 0,
  ZENDESK_WIDGET: 0,
  ZENDESK_WIDGET_LOADED: 0,
});

const initialState = {
  zendeskWidget: { loaded: false },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ZENDESK_WIDGET_LOADED:
      return {
        ...state,
        zendeskWidget: { loaded: action.loaded },
      };

    default:
      return state;
  }
};

export const actions = {};
